import request from '@/utils/request'

let ContactApi = {

  /*用工申请联系列表*/
  list(data) {
    return request._post('/shop/plus.contact.Index/index', data);
},
/*添加用工申请联系*/
add(data) {
    return request._post('/shop/plus.contact.Index/add', data);
},
/*修改用工申请联系*/
edit(data) {
    return request._post('/shop/plus.contact.Index/edit', data);
},
/*删除用工申请联系*/
del(data) {
    return request._post('/shop/plus.contact.Index/del', data);
},
/*用工申请联系详情*/
detail(data) {
  return request._post('/shop/plus.contact.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.contact.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.contact.Setting/getSetting', data, errorback);
    },
    passCanel(data, errorback) {
        return request._post('/shop/plus.contact.Index/passCanel', data, errorback);
      },
}
export default ContactApi;



// WEBPACK FOOTER //
// ./src/api/contact.js